import React, { useEffect } from 'react';
import { Modal as AntModal, ModalProps as AntModalProps } from 'antd';
import { Row, Col } from 'antd';
import CustomButton from '../Button/Button';
import CustomLabel from '../Label/CustomLabel';

interface ModalProps extends AntModalProps {
  title: string;
  children: React.ReactNode;
  open: boolean;
}

const Modal: React.FC<ModalProps> = ({ title, open, children, ...props }) => (
  <AntModal
    title={title}
    onCancel={props.onCancel}
    open={open}
    footer={null}
    centered
    width={800}
    destroyOnClose
  >
    {children}
  </AntModal>
);

// 🔹 Agregamos las propiedades faltantes a la interfaz
interface CustomModalProps extends ModalProps {
  footerLeft?: React.ReactNode;
  footerRight?: React.ReactNode;
  onSave?: () => void;
  onClose?: () => void;
  labelSubmit?: string;
  labelCancel?: string;
  isLoading?: boolean;
  isLoadingSave?: boolean;
  disabledBtn?: boolean;
  disabledCancel?: boolean;
}

const CustomModal: React.FC<CustomModalProps> = ({
  title,
  children,
  footerLeft,
  footerRight,
  onClose,
  onCancel,
  onSave,
  labelSubmit,
  labelCancel = 'Cancelar',
  isLoading = false,
  isLoadingSave = false,
  disabledBtn = false,
  disabledCancel = false,
  open,
  ...props
}) => {
  return (
    <AntModal
      {...props}
      closable={!disabledCancel}
      maskClosable={!disabledCancel}
      closeIcon={<span className="custom-close-icon">x</span>}
      onCancel={onClose ?? onCancel}
      open={open}
      title={
        <div className="custom-modal-title-container mb-32">
          <CustomLabel text={title} level={4} align="left" />
        </div>
      }
      footer={
        <Row justify="space-between" align="middle">
          <Col>{footerLeft && footerLeft}</Col>
          <Col>
            {footerRight ? (
              footerRight
            ) : (
              <>
                {labelCancel && (
                  <CustomButton
                    buttonType="secondary"
                    label={labelCancel}
                    onClick={onCancel}
                    size="middle"
                    style={{ marginRight: '8px' }}
                    disabled={disabledCancel}
                  />
                )}

                {labelSubmit && (
                  <CustomButton
                    label={labelSubmit}
                    loading={isLoadingSave}
                    onClick={onSave}
                    size="middle"
                    disabled={disabledBtn}
                  />
                )}
              </>
            )}
          </Col>
        </Row>
      }
    >
      {children}
    </AntModal>
  );
};

export default CustomModal;
